import { CompanyType } from '@upright/common/model/input/companies/types';
import { ModelEntityType } from '@upright/common/model/input/types';
import { useCompany } from '@upright/ui/api/model/input/companies';
import { useNetImpactLensContext } from '@upright/ui/common/upright/core/impact-lenses/net-impact/common/use-net-impact-lens-context';
import { ComplexImpactDetailsInfoModal } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/complex-info-modal';
import { SimpleImpactDetailsInfoBox } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/simple-info-box';

export function SingleImpactInfoBox() {
  const lensContext = useNetImpactLensContext();
  const selection = lensContext?.state;
  const valence = selection?.valence;
  const impact = selection?.impact;

  const isCompanyEntity = lensContext?.data?.entity?.type === ModelEntityType.COMPANY;
  const companyId = lensContext?.data?.entity?.id;

  if (impact && valence && isCompanyEntity && companyId) {
    return <CompanyImpactDetailsInfoModal companyId={companyId} />;
  }

  // Show simple impact details info boxes for non-company entities.
  return <SimpleImpactDetailsInfoBox />;
}

const CompanyImpactDetailsInfoModal = (props: { companyId: string }) => {
  const companyQuery = useCompany(props.companyId);
  const company = companyQuery.data;

  // Show complex impact details info modal if user is looking at a proper company
  // (not a green bond, company group, portfolio or 'not-a-company') and the user has clicked
  // on an impact bar.
  if (company?.type === CompanyType.COMPANY || company?.type === CompanyType.CUSTOMER_SCENARIO) {
    return <ComplexImpactDetailsInfoModal />;
  }

  // Show simple impact details info boxes only if detailed info modal
  // is not shown.
  return <SimpleImpactDetailsInfoBox />;
};
